export default "__VITE_ASSET__1228c499__"